export default __webpack_public_path__ + "static/media/subtopicicon.486d3f86.svg";